import dayjs from 'dayjs';

export type OffsetDateTime = dayjs.Dayjs;

export function offsetDateTime(string: string): OffsetDateTime {
  return dayjs(string);
}
